export class Product {

    id: number;
    cat: number;
    quantity: number;
    name: string;
    comment: string;
    price: number;
    weight: number;
    total_ttc: number;
    unit_ttc: any;
    product_type: number;
    details: any[];
    categories: number[];
    description: string;
    image: string[];
    old_total_after_period: any;
    stock: any | null;
    quantities: any[];
    has_stock: any | null;
    fidelity_points: number;
    use_fidelity_points: number = 0;
    free: number = 0;
    uid: any;
    rubric: any;
    display_lang: any;
    id_tax_grouping: any;
    suggestions: any;


    constructor(
        id: any,
        cat: any,
        quantity: any,
        name: string,
        comment: string,
        price: any,
        weight: any,
        product_type: any,
        details: any[],
        categories: number[],
        description: string,
        image: string[],
        stock: any | null,
        has_stock: any | null,
        fidelity_points: any,
        use_fidelity_points: any,
        free: any,
        uid: any,
        rubric: any,
        display_lang: any,
        id_tax_grouping: any,
        suggestions: any



    ) {
        this.id = parseInt(id);
        this.cat = parseInt(cat);
        this.quantity = parseInt(quantity);
        this.name = name;
        this.comment = comment;
        this.price = parseFloat(price);
        this.weight = parseFloat(weight);
        this.product_type = parseInt(product_type);
        this.details = details;
        this.categories = categories;
        this.total_ttc = this.getTotal();
        this.description = description;
        this.image = image;
        this.old_total_after_period = null;
        this.stock = stock;
        this.quantities = this.initNumQuant();
        this.has_stock = has_stock;
        this.fidelity_points = fidelity_points;
        this.use_fidelity_points = use_fidelity_points;
        this.free = free;
        this.uid = uid;
        this.rubric = rubric;


        this.display_lang = display_lang;
        this.id_tax_grouping = id_tax_grouping;

        this.suggestions = suggestions;





    }

    getTotal() {


        let countTot = 0;

        this.details.map(det => {


            countTot += (det.price * det.quantity)


            if (det.details) {
                det.details.map((sdet: any) => {
                    countTot += (sdet.price * sdet.quantity);
                });
            }

        });

        const total = !this.free ? (this.price * this.quantity) + (countTot * this.quantity) : 0;

        return (Math.round(total * 100) / 100);
    }





    /**
     * @description Initialise le tableau de quantités selectionnables du produit
     * @return {number}
     */
    initNumQuant(): number[] {
        let arrayQuants = [];
        let min = 1;

        let max = 30;

        while (min <= max) {
            arrayQuants.push(min);
            min++;
        }


        return arrayQuants;
    }
}
